export type Testimonial = {
  name: string;
  role: string;
  initial: string;
  tone: "primary" | "accent" | "secondary";
  content: string;
};

export const testimonials: Testimonial[] = [
  {
    name: "陈默",
    role: "自由撰稿人 · 杭州",
    initial: "陈",
    tone: "primary",
    content:
      "第一次投稿完全不知道编辑在想什么，照着爆款特征清单改了标题和开头，当天下午就收到复审消息。这是我投过最省心的一次。",
  },
  {
    name: "李女士",
    role: "消费者 · 成都",
    initial: "李",
    tone: "accent",
    content:
      "我把退费材料按投稿指南里的顺序整理好交上去，编辑说证据链很完整，还教我怎么补充聊天记录。现在我身边朋友维权都来问我。",
  },
  {
    name: "王工",
    role: "行业从业者 · 深圳",
    initial: "王",
    tone: "secondary",
    content:
      "选题库里的行业选题很实在，标注了截止时间和编辑想要的角度。我不擅长写稿，但把知道的内情按提示填进去，就被采用了。",
  },
  {
    name: "小镇青年阿凯",
    role: "本地资讯爱好者 · 洛阳",
    initial: "阿",
    tone: "primary",
    content:
      "以前都是拍完视频发自己账号，流量起不来。投稿后才明白标题差在哪里，编辑帮我改了一版，播放量完全不是一个量级。",
  },
  {
    name: "周编辑",
    role: "内容审核 · 合作媒体",
    initial: "周",
    tone: "accent",
    content:
      "通过爆点社转来的稿件，材料完整度和真实性统计上明显更好，编辑沟通成本低了很多，很愿意长期合作。",
  },
  {
    name: "匿名线人",
    role: "行业内部 · 不便具名",
    initial: "匿",
    tone: "secondary",
    content:
      "最看重的是保护机制。投稿前我先问了匿名会不会被追溯，编辑给了明确的流程说明，之后才放心把材料交出去。",
  },
];